import ReadMoreToggle from '../../components/readmore.js';
import ImageCarousel from '../../components/image-carousel.js';

function initAboutPage() {
  new ReadMoreToggle();

  const carousels = document.querySelectorAll('.carousel-container');
  if (carousels.length) {
    carousels.forEach((el) => {
      new ImageCarousel(el);
    });
  }

  console.log('✅ About page initialized');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAboutPage);
} else {
  initAboutPage();
}
